import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { localizeSpa } from '../../../utils/brand';

const PageTitle: React.FC<{title:string}> = ({title}) => {
  const location = useLocation();

  useEffect(() => {
    document.title = localizeSpa(title);
  }, [location, title]);

  return null;
};

export default PageTitle;